export const LABEL_DETAILS_LABELS = {
	SECTION_TITLE: 'Label details',
	KEY_LABEL: 'Key',
	DISPLAY_NAME_LABEL: 'Key display name',
	DISPLAY_NAME_TOOLTIP:
		'Web SDKs show the key display name as UnitID/Environment, even if you rename it',
	DESCRIPTION_LABEL: 'Key description',
	DESCRIPTION_TOOLTIP: 'Users will see the key description when selecting label values',
	DESCRIPTION_HINT: "Explain the key's purpose or intended use",
	KEY_PLACEHOLDER: 'Example: Team, Flow',
	DISPLAY_NAME_PLACEHOLDER: 'Example: Team, Flow'
} as const;
